module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9gILg"))).then(() => parcelRequire('hEqeo'));